import { apiDeleteComplianceService, apiPutComplianceService, buildMerchantId, buildMerchantIdForEmployeeKey } from '../utils/api'

export function updateMerchant(companyId, shopId, data) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiPutComplianceService(`merchants/${merchantId}`, data)
}

export function updateMerchantEmployeeKey(companyId, employeeId, data) {
  const merchantId = buildMerchantIdForEmployeeKey(companyId)
  return apiPutComplianceService(`merchants/${merchantId}/employees/${employeeId}`, data)
}

export function deletedMerchantEmployeeKey(companyId, employeeId) {
  const merchantId = buildMerchantIdForEmployeeKey(companyId)
  const params = { compliance: 'METRC' }
  return apiDeleteComplianceService(`merchants/${merchantId}/employees/${employeeId}/credentials`, params)
}


// WEBPACK FOOTER //
// ./src/api/complianceService.js